import { useMutation, useQueryClient } from 'react-query'
import { useAppointmentsService } from '../services'
import { providerScheduleQueryKey } from '../useProviderSchedule'

const useReleasePoolHold = () => {
  const { releasePoolHold } = useAppointmentsService()
  const queryClient = useQueryClient()

  return useMutation(releasePoolHold, {
    // Returning the promise makes react-query wait for the refetch, so the dialog closes on fresh data.
    onSuccess: () => queryClient.invalidateQueries([providerScheduleQueryKey]),
  })
}

export { useReleasePoolHold }
